/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TenantDecommissionVerificationDto
 */
export interface TenantDecommissionVerificationDto {
    /**
     * 
     * @type {string}
     * @memberof TenantDecommissionVerificationDto
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDecommissionVerificationDto
     */
    tenantName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TenantDecommissionVerificationDto
     */
    decommissioned?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TenantDecommissionVerificationDto
     */
    activeUserTenantAssociations?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantDecommissionVerificationDto
     */
    activeSessions?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantDecommissionVerificationDto
     */
    domainBindings?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantDecommissionVerificationDto
     */
    activeTenantRelationships?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantDecommissionVerificationDto
     */
    activeUserRoles?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantDecommissionVerificationDto
     */
    activeGroupRoles?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantDecommissionVerificationDto
     */
    activeGroupUsers?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantDecommissionVerificationDto
     */
    activeGroups?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantDecommissionVerificationDto
     */
    activeRoles?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantDecommissionVerificationDto
     */
    activeConfigurations?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantDecommissionVerificationDto
     */
    unresolvedCases?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantDecommissionVerificationDto
     */
    customerTenantRelationships?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantDecommissionVerificationDto
     */
    activeDomainMappings?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantDecommissionVerificationDto
     */
    rolePermissions?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantDecommissionVerificationDto
     */
    issues?: Array<string>;
}

/**
 * Check if a given object implements the TenantDecommissionVerificationDto interface.
 */
export function instanceOfTenantDecommissionVerificationDto(value: object): value is TenantDecommissionVerificationDto {
    return true;
}

export function TenantDecommissionVerificationDtoFromJSON(json: any): TenantDecommissionVerificationDto {
    return TenantDecommissionVerificationDtoFromJSONTyped(json, false);
}

export function TenantDecommissionVerificationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantDecommissionVerificationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'tenantName': json['tenantName'] == null ? undefined : json['tenantName'],
        'decommissioned': json['decommissioned'] == null ? undefined : json['decommissioned'],
        'activeUserTenantAssociations': json['activeUserTenantAssociations'] == null ? undefined : json['activeUserTenantAssociations'],
        'activeSessions': json['activeSessions'] == null ? undefined : json['activeSessions'],
        'domainBindings': json['domainBindings'] == null ? undefined : json['domainBindings'],
        'activeTenantRelationships': json['activeTenantRelationships'] == null ? undefined : json['activeTenantRelationships'],
        'activeUserRoles': json['activeUserRoles'] == null ? undefined : json['activeUserRoles'],
        'activeGroupRoles': json['activeGroupRoles'] == null ? undefined : json['activeGroupRoles'],
        'activeGroupUsers': json['activeGroupUsers'] == null ? undefined : json['activeGroupUsers'],
        'activeGroups': json['activeGroups'] == null ? undefined : json['activeGroups'],
        'activeRoles': json['activeRoles'] == null ? undefined : json['activeRoles'],
        'activeConfigurations': json['activeConfigurations'] == null ? undefined : json['activeConfigurations'],
        'unresolvedCases': json['unresolvedCases'] == null ? undefined : json['unresolvedCases'],
        'customerTenantRelationships': json['customerTenantRelationships'] == null ? undefined : json['customerTenantRelationships'],
        'activeDomainMappings': json['activeDomainMappings'] == null ? undefined : json['activeDomainMappings'],
        'rolePermissions': json['rolePermissions'] == null ? undefined : json['rolePermissions'],
        'issues': json['issues'] == null ? undefined : json['issues'],
    };
}

export function TenantDecommissionVerificationDtoToJSON(json: any): TenantDecommissionVerificationDto {
    return TenantDecommissionVerificationDtoToJSONTyped(json, false);
}

export function TenantDecommissionVerificationDtoToJSONTyped(value?: TenantDecommissionVerificationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': value['tenantId'],
        'tenantName': value['tenantName'],
        'decommissioned': value['decommissioned'],
        'activeUserTenantAssociations': value['activeUserTenantAssociations'],
        'activeSessions': value['activeSessions'],
        'domainBindings': value['domainBindings'],
        'activeTenantRelationships': value['activeTenantRelationships'],
        'activeUserRoles': value['activeUserRoles'],
        'activeGroupRoles': value['activeGroupRoles'],
        'activeGroupUsers': value['activeGroupUsers'],
        'activeGroups': value['activeGroups'],
        'activeRoles': value['activeRoles'],
        'activeConfigurations': value['activeConfigurations'],
        'unresolvedCases': value['unresolvedCases'],
        'customerTenantRelationships': value['customerTenantRelationships'],
        'activeDomainMappings': value['activeDomainMappings'],
        'rolePermissions': value['rolePermissions'],
        'issues': value['issues'],
    };
}

